var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTelegramMobile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.066,
    y: 0.423,
    width: 32.185,
    height: 32.185,
    rx: 16.093,
    fill: "#6B47F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17054_6065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.042 10.097a1.373 1.373 0 0 0-1.394-.217L9.632 14.731a1.37 1.37 0 0 0 .07 2.56l2.43.846 1.355 4.48a.67.67 0 0 0 .08.17c.005.008.012.014.018.021a.662.662 0 0 0 .188.178.664.664 0 0 0 .209.092h.008l.004.002c.045.01.09.014.136.014l.012-.002a.667.667 0 0 0 .202-.035c.015-.005.028-.014.043-.02a.668.668 0 0 0 .137-.077l.102-.086 1.812-2 2.702 2.093c.238.185.531.286.832.286a1.379 1.379 0 0 0 1.347-1.095l2.188-10.74a1.36 1.36 0 0 0-.465-1.32zm-8.646 8.254a.666.666 0 0 0-.183.339l-.208 1.008-.525-1.739 2.725-1.419-1.81 1.81zm5.566 3.556l-3.193-2.474a.672.672 0 0 0-.908.08l-.58.64.205-.996 4.75-4.75a.67.67 0 0 0-.785-1.068l-6.816 3.548-2.497-.913 12.055-4.823-2.231 10.756z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17054_6065"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8.113 8.47)",
    d: "M0 0H16.093V16.093H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTelegramMobile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/telegram_mobile.82acc05e.svg";
export { ForwardRef as ReactComponent };